export default __webpack_public_path__ + "static/bansouImage-11fdb7897dd2715f4198ccd786314381.webp";